import { render } from "./site_import_temaplate_button.vue?vue&type=template&id=d1918544"
import script from "./site_import_temaplate_button.vue?vue&type=script&lang=js"
export * from "./site_import_temaplate_button.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__